export const DEFAULT_LOCALE = 'en'
export const SUPPORTED_LOCALE_PREFIXES = ['en', 'de', 'es', 'fr', 'pt', 'ru', 'ja', 'zh-cn']
export const SUPPORTED_NON_DEFAULT_LOCALE_PREFIXES =
  SUPPORTED_LOCALE_PREFIXES.filter((locale) => locale !== DEFAULT_LOCALE)

export const normalizeLocale = (locale, defaultLocale = DEFAULT_LOCALE) => {
  if (!locale || typeof locale !== 'string') {
    return null
  }

  const normalizedLocale = locale.trim().toLowerCase()
  const normalizedDefaultLocale = String(defaultLocale || DEFAULT_LOCALE).trim().toLowerCase()

  if (!normalizedLocale || normalizedLocale === normalizedDefaultLocale) {
    return null
  }

  if (!SUPPORTED_LOCALE_PREFIXES.includes(normalizedLocale)) {
    return null
  }

  return normalizedLocale
}

const getLocaleParam = () => {
  if (typeof window === 'undefined') {
    return null
  }

  const localeFromI18n = window.I18n && window.I18n.locale
  const localeFromDom = typeof document !== 'undefined'
    ? document.documentElement.getAttribute('lang')
    : null
  const defaultLocale = window.I18n && window.I18n.defaultLocale
  const locale = localeFromI18n || localeFromDom

  return normalizeLocale(locale, defaultLocale)
}

export default getLocaleParam
